export enum EOnboardingMeetingStatus {
  COMPLETED = 'completed',
  PENDING = 'pending',
  SCHEDULED = 'scheduled',
  RESCHEDULED = 'rescheduled',
  NOSHOW = 'noshow',
  CANCELED = 'canceled'
}
